import { render, staticRenderFns } from "./tool1.vue?vue&type=template&id=bb364b1a&scoped=true"
import script from "./tool1.vue?vue&type=script&lang=ts"
export * from "./tool1.vue?vue&type=script&lang=ts"
import style0 from "./tool1.vue?vue&type=style&index=0&id=bb364b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb364b1a",
  null
  
)

export default component.exports